import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import PropTypes from "prop-types";
import React from "react";
import environment from "web/script/modules/environment";
import LegalAgreement from "web/react/components/legal-agreement/legal-agreement";
import Button from "web/react/components/button/button";
import SocialButton from "web/react/components/social-button/social-button";
import styles from "./email-capture-form.css";
export function EmailCaptureForm(_ref) {
  var captureType = _ref.captureType,
      className = _ref.className,
      emailAddress = _ref.emailAddress,
      emailLabelText = _ref.emailLabelText,
      formErrors = _ref.formErrors,
      onEmailChange = _ref.onEmailChange,
      onLegalChange = _ref.onLegalChange,
      onSubmit = _ref.onSubmit,
      privacyPolicyLink = _ref.privacyPolicyLink,
      submitText = _ref.submitText,
      submitClass = _ref.submitClass,
      termsAndConditionsLink = _ref.termsAndConditionsLink,
      cookiePolicyLink = _ref.cookiePolicyLink,
      shortPolicy = _ref.shortPolicy,
      showSocial = _ref.showSocial,
      _ref$hideEmail = _ref.hideEmail,
      hideEmail = _ref$hideEmail === void 0 ? false : _ref$hideEmail,
      onSocialClick = _ref.onSocialClick,
      isFBPDP = _ref.isFBPDP,
      signInLinkProps = _ref.signInLinkProps;
  var country = environment.get("country");
  var requiresOptIn = country !== "US";

  function generateErrorDiv(message, key) {
    return React.createElement("div", {
      key: key,
      className: styles.formItemError
    }, React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: message
      }
    }));
  }

  var errors = {
    email: undefined,
    legal: undefined,
    other: undefined
  };

  if (formErrors !== undefined) {
    Object.keys(formErrors).map(function (key) {
      if (key === "marketing_emails" || key === "privacy_policy") {
        analytics.event(captureType, "sign up", "error_marketing");
        errors.legal = formErrors[key].map(function (message, id) {
          return generateErrorDiv(message, id);
        });
      } else if (key === "email") {
        analytics.event(captureType, "sign up", "error_invalid_email");
        errors.email = formErrors[key].map(function (message, id) {
          return generateErrorDiv(message, id);
        });
      } else if (key === "existing_user") {
        analytics.event(captureType, "sign up", "error_existing_user");
        errors.email = formErrors[key].map(function (message, id) {
          return generateErrorDiv(message, id);
        });
      } else {
        errors.other = formErrors[key].map(function (message, id) {
          return generateErrorDiv(message, id);
        });
      }
    });
  }

  var email = React.createElement("fieldset", {
    className: styles.fieldset
  }, !isFBPDP && React.createElement("label", {
    className: styles.label,
    htmlFor: "id_email"
  }, emailLabelText || gettext("account.form.email_label")), React.createElement("input", {
    type: "email",
    name: "email",
    value: emailAddress,
    onClick: function onClick() {
      return analytics.event(captureType, "fill_field", "field_email");
    },
    className: styles.input,
    placeholder: gettext("account.form.email_placeholder"),
    autoCapitalize: "off",
    onChange: onEmailChange,
    autoFocus: true,
    required: true
  }), errors.email);
  var hasEmailAndSocial = !hideEmail && showSocial;
  var social = React.createElement("div", {
    className: styles.socialArea
  }, hasEmailAndSocial && React.createElement("span", {
    className: styles.orSeparator
  }, gettext("in_stock_product.or_separator")), React.createElement(SocialButton, {
    className: styles.facebookButton,
    type: "facebook",
    onClick: function onClick() {
      return onSocialClick("facebook");
    },
    fullWidth: true
  }, gettext("account.register.sign_up_with_facebook")), React.createElement(SocialButton, {
    type: "google",
    onClick: function onClick() {
      return onSocialClick("google-oauth2");
    },
    fullWidth: true
  }, gettext("account.register.sign_up_with_google")));
  var legal = React.createElement("div", {
    className: styles.legalAgreementWrapper
  }, React.createElement(LegalAgreement, {
    requiresOptIn: requiresOptIn,
    submitText: submitText,
    handleLegalChange: onLegalChange,
    captureType: captureType,
    privacyPolicyLink: privacyPolicyLink,
    termsAndConditionsLink: termsAndConditionsLink,
    cookiePolicyLink: cookiePolicyLink,
    shortVersion: shortPolicy
  }), errors.legal);
  var buttons = React.createElement(React.Fragment, null, requiresOptIn && legal, !hideEmail && React.createElement(Button, {
    styleType: "primary",
    className: classnames(submitClass, styles.submitButton),
    type: "submit",
    fullWidth: true
  }, submitText), errors.other, showSocial === true && social, !requiresOptIn && legal);
  var privacyPolicyLinkProps = "href=".concat(privacyPolicyLink, " target=\"_blank\"");
  var termsAndConditionsLinkProps = "href=".concat(termsAndConditionsLink, " target=\"_blank\"");
  var policyText = React.createElement("div", {
    className: styles.legalAgreementSmall,
    dangerouslySetInnerHTML: {
      // "By creating an account, you consent to Lyst’s Terms & Conditions.
      // To learn more about how Lyst uses and protects your personal data, please read Lyst’s Privacy Policy."
      __html: gettext("account.register.legal_agreement.sign_up_opt_in_terms", {
        terms_and_conditions_link_props: termsAndConditionsLinkProps,
        privacy_policy_link_props: privacyPolicyLinkProps
      })
    }
  });
  var signInText = null;

  if (signInLinkProps) {
    var signInLinkProp = "href=".concat(signInLinkProps, "&email=").concat(emailAddress, " target=\"_blank\"");
    signInText = React.createElement("div", {
      className: styles.signinBox,
      dangerouslySetInnerHTML: {
        __html: gettext("account.register.existing_user_sign_in_link_text", {
          sign_in_link_props: signInLinkProp
        })
      }
    });
  }

  return React.createElement("form", {
    className: classnames(className, styles.form),
    onSubmit: onSubmit
  }, !hideEmail && email, signInLinkProps && signInText, buttons, requiresOptIn && shortPolicy && policyText);
}
export default EmailCaptureForm;
EmailCaptureForm.propTypes = {
  captureType: PropTypes.string.isRequired,
  className: PropTypes.string,
  cookiePolicyLink: PropTypes.string,
  emailAddress: PropTypes.string,
  emailLabelText: PropTypes.string,
  formErrors: PropTypes.object,
  onEmailChange: PropTypes.func.isRequired,
  onLegalChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSocialClick: PropTypes.func,
  showSocial: PropTypes.bool,
  hideEmail: PropTypes.bool,
  privacyPolicyLink: PropTypes.string.isRequired,
  submitText: PropTypes.string.isRequired,
  submitClass: PropTypes.string,
  termsAndConditionsLink: PropTypes.string,
  shortPolicy: PropTypes.bool,
  isFBPDP: PropTypes.bool,
  signInLinkProps: PropTypes.string
};